//电站/ 电表配置管理 api
import request from '@/util/request'


// 获取日发电偏移量列表
export function getGenerationOffsetDayList(id,data) {
    return request({
        url: `/maintain-s/station/${id}/metering/generation/offset`,
        method: 'get',
        params: data
    });
}
// 获取日发电偏移量列表---新方法
export function getOffsetList(id,params,data){
	return request({
    url: `/maintain-s/station/${id}/metering/generation/offsetLimit`,
    method: 'post',
    params,
    data
  })
}
//添加日发电偏移量
export function addGenerationOffsetDay(id,data) {
    return request({
        url: `/maintain-s/station/${id}/metering/generation/offset`,
		method: 'post',
		data
    });
}

// 删除日发电偏移量
export function delGenerationOffsetDay(id,correctionId) {
    return request({
        url: `/maintain-s/station/${id}/metering/generation/offset/${correctionId}`,
		method: 'delete'
    });
}

// 配置总发电偏移量
export function configTotal(id, data) {
    return request({
        url: `/maintain-s/station/${id}/metering/generation/offset/total`,
		method: 'post',
	    data
    });
}
// 获取合计发电偏移量
export function configAll(id) {
    return request({
        url: `/maintain-s/station/${id}/metering/generation/offset/total`,
		method: 'get',
    });
}
//数据来源重复验证
//export function dataRepeatHint(id){
//  return request({
//      url:`/maintain-s/station/${id}/repeat/hint`,
//      method:'get'
//  });
//}
////配置数据来源重复提示
//export function configRepeatHint(id,bool){
//  return request({
//      url:`/maintain-s/station/${id}/repeat/hint/${bool}`,
//      method:'post'
//  })
//}
//数据来源配置可用选项和默认选项
export function configSelect(id){
    return request({
        url:`/maintain-s/station/${id}/metering/hint`,
        method:'get'
    })
}
//电表配置-获取电表产品规格
export function GetMeterPro(stationId,deviceId){
    return request({
        url:`/maintain-s/power/system/${stationId}/meter/${deviceId}/spec`,
        method:'get'
    })
}

// 电表配置
export function meterConfig(id,deviceId,data){
    return request({
        url:`/maintain-s/power/system/${id}/meter/${deviceId}/config`,
		method:'post',
		data
    })
}
//获取电站发电计划
export function generatePlan(id){
    return request({
        url:`/maintain_old/station/${id}/plan/generation`,
        method:'get'
    })
}
//更新电站发电计划
export function addGeneratePlan(id,data){
    return request({
        url:`/maintain_old/station/${id}/plan/generation`,
        method:'post',
        data
    })
}
//自发自用比例来源设置
export function consumptionSource(id,data){
    return request({
        url:`/maintain_old/station/${id}/metering/consumption/source`,
        method:'post',
        params:data
    })
}
//尝试数据爬取
export function postCrawlTry(id,data){
    return request({
        url:`/maintain_old/station/${id}/crawl/try`,
        method:'post',
        data
    })
}
//获取数据爬取配置信息
export function getCrawlConfig(id){
    return request({
        url:`/maintain_old/station/${id}/crawl/config`,
        method:'get'
    })
}
//更新数据爬取配置信息
export function postCrawlConfig(id,data){
    return request({
        url:`/maintain_old/station/${id}/crawl/config`,
        method:'post',
        data
    })
}
//获取爬虫数据爬取最新统计
export function newestCrawlStats(id){
    return request({
        url:`/maintain_old/station/${id}/crawl/stats`,
        method:'get'
    })
}
//数据爬取启停
export function crawlProcess(id,data){
    return request({
        url:`/maintain_old/station/${id}/crawl/process`,
        method:'post',
        data
    })
}
//下载
export function downLoadCrawl(id){
    return request({
        url:`/maintain_old/station/${id}/crawl/record/excel`,
        method:'get',
        responseType: 'blob'
    })
}


// WEBPACK FOOTER //
// ./src/api/maintain/config/index.js